import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import "rxjs/add/operator/timeoutWith";
import "rxjs/add/observable/defer"
import "rxjs/add/observable/throw"

import { DataViewModel } from '../../models/DataViewModel';
import { AppConfiguration } from '../../models/common/appConfiguration';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

@Injectable()
export class AppService {
    baseUrl: string;

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string,) {
        this.baseUrl = baseUrl;
    }

    public loadConfiguration(func: (config: AppConfiguration) => void): void {
        this.http.get<DataViewModel<AppConfiguration>>(this.baseUrl + 'api/AppConfiguration/LoadApplicationConfiguration')
            .map(response => {
                var a = response;
                return <DataViewModel<AppConfiguration>>response;
            })
            .catch(this.handleError)
            .subscribe(response => {
                if (response.success) {
                    func(response.data);
                }
            });
    }

    private handleError(response: ErrorObservable ) {
        console.error(response);
        return Observable.throw(response.error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/common/app.service.ts